// src/components/Header.jsx
import React, { useEffect, useState, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import "./../styles/Header.css";
import Navbar from "./Navbar";
import LearnHutLogo from "../Logos To be used/learnhut_logo_recolored.png";

// Profile icon (SVG)
import { ReactComponent as ProfileIcon } from "../Logos To be used/Profile icon.svg";

const Header = () => {
  const [isNavbarVisible, setNavbarVisible] = useState(false);
  const navbarRef = useRef(null);

  const toggleNavbar = (e) => {
    e.stopPropagation();
    setNavbarVisible((prev) => !prev);
  };

  const closeNavbar = (e) => {
    if (navbarRef.current && !navbarRef.current.contains(e.target)) {
      setNavbarVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", closeNavbar);
    return () => document.removeEventListener("click", closeNavbar);
  }, []);

  const role = localStorage.getItem("userRole");
  const isTutor = role === "TUTOR" || role === "ADMIN";
  const tutorViewMode = localStorage.getItem("tutorViewMode") || "tutor";
  const isTutorEditMode = isTutor && tutorViewMode !== "student";
  const dashboardPath = isTutor ? "/dashboard-tutor" : "/dashboard";

  const handleBrandClick = useCallback(() => {
    if (isTutor) {
      localStorage.setItem("tutorViewMode", "tutor");
    }
  }, [isTutor]);

  return (
    <header className="header">
      <div className="header-inner">
        <div className="brand-cluster">
          <Link to={dashboardPath} className="brand-link" onClick={handleBrandClick}>
            <img
              src={LearnHutLogo}
              className="logo"
              alt="LearnHut Logo"
            />
          </Link>

          <div className="vertical-bar left-bar"></div>

          <Link
            to={dashboardPath}
            className="webapp-title-wrap"
            onClick={handleBrandClick}
          >
            <span className="webapp-beta">BETA</span>
          </Link>
        </div>

        <div className="header-right">
          <div className="header-upcoming">
            <span className="header-upcoming-item" data-info="Kommt später">
              Meine Fächer
            </span>
            {isTutor && (
              <Link className="header-nav-link" to="/check-gtm-1">
                GTM I Check
              </Link>
            )}
            {!isTutorEditMode && (
              <Link className="header-nav-link" to="/klausuren">
                Klausuren
              </Link>
            )}
          </div>

          <button
            type="button"
            className="profile-icon-btn"
            onClick={toggleNavbar}
            aria-label="Open profile menu"
            aria-expanded={isNavbarVisible}
          >
            <ProfileIcon className="profile-icon" />
          </button>
        </div>
      </div>

      {isNavbarVisible && (
        <div
          ref={navbarRef}
          className="navbar"
          onClick={(e) => e.stopPropagation()}
        >
          <Navbar />
        </div>
      )}

      <div className="horizontal-bar"></div>
    </header>
  );
};

export default Header;
